import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Alert } from "@amzn/lcars-core-ui-components"
import Column from "@amzn/meridian/column"
import Text from "@amzn/meridian/text"
import Spinner from "src/components/Spinner"
import { handleCallback } from "src/services/authService"

/**
 * OAuth2 callback target. Cognito redirects here with ?code=...; we
 * exchange the code for tokens and navigate to Home. On failure we show
 * the error so the operator can retry or report it.
 */

const Callback: React.FC = () => {
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const code = params.get("code")
    const oauthError = params.get("error_description") ?? params.get("error")

    if (oauthError) {
      setError(oauthError)
      return
    }
    if (!code) {
      setError("Missing authorization code.")
      return
    }

    handleCallback(code)
      .then(() => {
        // Restore the page the user was trying to visit before auth redirect
        const returnTo = sessionStorage.getItem("eclipse_hhu_return_to") || "/"
        sessionStorage.removeItem("eclipse_hhu_return_to")
        navigate(returnTo, { replace: true })
      })
      .catch((err) => setError(err instanceof Error ? err.message : String(err)))
  }, [navigate])

  if (error) {
    return (
      <Column spacing="medium" spacingInset="400">
        <Alert type="error" primaryText={error} />
        <Text>Please return to the home page and try again.</Text>
      </Column>
    )
  }

  return <Spinner label="Signing in…" />
}

export default Callback
